import { BaseComponent } from '../../base-component';
import { trackEvent, trackView } from '@otto-ec/nexus-registry/pdp/tracking';

export class DescriptionComponent extends BaseComponent {
    public rootSelector = '.js_pdp_description';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        const expanderElement = this.getChildElement<HTMLOcExpanderV1Element>('.js_pdp_description__expander');
        expanderElement.addEventListener('oc-open', () => this.handleExpanderOpened());
        expanderElement.addEventListener('oc-close', () => this.handleExpanderClosed());

        this.performViewTracking(expanderElement);
    }

    private performViewTracking(expanderElement: HTMLOcExpanderV1Element): void {
        trackView({
            product_Description: [expanderElement.isCutOff ? 'foldable' : 'not_foldable'],
        });
    }

    private handleExpanderOpened(): void {
        trackEvent({
            product_Description: ['more'],
        });
    }

    private handleExpanderClosed(): void {
        trackEvent({
            product_Description: ['less'],
        });

        this.getRootElement().scrollIntoView();
    }
}
